/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : StartNode.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { Handle, Position } from "reactflow";
import { registerNode } from "../registry/NodeRegistry";

function StartNode({ selected }) {
  return (
    <Box
      sx={{
        display: "flex",
        width: 360,
        bgcolor: "#e4e4e4",
        borderRadius: 0,
        border: "1px solid",
        borderColor: selected ? "#26890D" : "#2b2b2b",
        boxShadow: "0 10px 10px rgba(0,0,0,0.6)",
        position: "relative",
        overflow: "visible",
      }}
    >
      {/* Accent bar */}
      <Box sx={{ width: 6, bgcolor: "#26890D" }} />

      {/* Content */}
      <Box sx={{ flex: 1, p: 2 }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <ArrowRightAltIcon fontSize="small" />
          <Typography fontWeight={600}>Start</Typography>

          <Box sx={{ flex: 1 }} />
        </Box>
      </Box>

      {/* Embedded output handle */}
      <Handle
        className="out-handle"
        type="source"
        position={Position.Right}
        id="out"
      />
    </Box>
  );
}

/* Registry remains identical */
registerNode({
  type: "start",
  label: "Start",
  getDefaultData() {
    return {};
  },
  getPorts() {
    return [{ id: "out", direction: "source" }];
  },
  renderNode: StartNode,
});

StartNode.propTypes = {
  selected: PropTypes.bool,
};

export default StartNode;
